export default "__VITE_ASSET__8VkV24Ow__"